export default __webpack_public_path__ + "static/ANA-MARIA-ANGEL-DIAS-DE-PODER-b625e3be6015476834efb24ba369f5f3.png";